import { IFieldValueEditable, IFieldsMeta } from '../interfaces';
import {
  ITabField,
  IFieldValueObject,
  PREDEFINED_FIELDS,
  BLANK_HTML,
  RESOURCE_FIELD_TYPE,
  ITableItem
} from '@logicmanager/common';
import { ISetTabStatus } from '../actions/ui/interfaces';
import { IUpdateValue } from '../actions/values/interfaces';

export function getValidatedFields(fieldsMeta: IFieldsMeta, fieldsValues: IFieldValueEditable,
                                   updateValueCallback: (id: string, fieldValue: IFieldValueObject) => IUpdateValue,
                                   setTabStatusCallback?: (tabId: string, opened: boolean) => ISetTabStatus,
                                   isCaptchaValid: boolean = true):
                                   IFieldValueEditable {

  let allFieldsValid: boolean = true;
  const reportedTypeVisible: boolean = isReportedTypeVisible(fieldsMeta, fieldsValues);

  Object.keys(fieldsValues).forEach((key: string) => {
    const fieldMeta: ITabField = fieldsMeta[key];
    const fieldValue: IFieldValueObject = fieldsValues[key];
    if (!reportedTypeVisible && fieldMeta.title && fieldMeta.title.toLowerCase() ===
      PREDEFINED_FIELDS.REPORTED_BY) {
      fieldsValues[key] = { ...fieldValue, visible: false };
      return;
    }
    if (fieldValue.visible) {
      if (!fieldValue.valid || fieldValue.incomplete) {
        allFieldsValid = false;
        if (setTabStatusCallback) { setTabStatusCallback(fieldValue.tabId, true); }
      }
      if (!fieldValue.incomplete && fieldMeta && fieldMeta.required && !fieldMeta.readOnly
        && (!fieldValue.value || fieldValue.value === BLANK_HTML)) {
        updateValueCallback(key, {
          incomplete: true
        });
        allFieldsValid = false;
        if (setTabStatusCallback) { setTabStatusCallback(fieldValue.tabId, true); }
      }
      if (fieldMeta && fieldMeta.fieldType === RESOURCE_FIELD_TYPE.TABLE) {
        if (fieldValue.tableItems) {
          fieldValue.tableItems.forEach((tableItem: ITableItem) => {
            if (tableItem.visible && !tableItem.valid) {
              allFieldsValid = false;
              if (setTabStatusCallback) { setTabStatusCallback(fieldValue.tabId, true); }
            }
          });
        }
      }
    }
  });
  if (!isCaptchaValid || !allFieldsValid) {
    return null;
  }
  return fieldsValues;
}

function isReportedTypeVisible(fieldsMeta: IFieldsMeta,
                               fieldsValues: IFieldValueEditable): boolean {
  const reportedTypeMeta: ITabField = getReportedTypeMeta(fieldsMeta);
  if (reportedTypeMeta && reportedTypeMeta.isConditional) {
    const reportedTypeValue: IFieldValueObject = fieldsValues[reportedTypeMeta.id];
    if (reportedTypeValue.visible === false) {
      return false;
    }
  }
  return true;
}

function getReportedTypeMeta(fieldsMeta: IFieldsMeta): ITabField {
  const reportedTypeKey: string = Object.keys(fieldsMeta)
    .find((key: string) =>
      fieldsMeta[key].title
      && fieldsMeta[key].predefined
      && fieldsMeta[key].title.toLowerCase() ===
      PREDEFINED_FIELDS.REPORTED_TYPE);
  const reportedTypeMeta: ITabField = fieldsMeta[reportedTypeKey];
  return reportedTypeMeta;
}
